import { UUID } from '@cmg/common';

export type EconomicsBreakdown = { cmgEntityKey: UUID; percentageValue: number };
export type EconomicsManager = { cmgEntityKey: UUID; firmName: string };

const getManagerEconomicsBreakdown = (
  breakdown: Readonly<EconomicsBreakdown[]>,
  managers: Readonly<EconomicsManager[]>
): { firmName: string; value: number }[] =>
  breakdown.map(val => {
    const manager = managers.find(man => man.cmgEntityKey === val.cmgEntityKey);
    return { value: val.percentageValue, firmName: manager?.firmName ?? '-' };
  });

export default getManagerEconomicsBreakdown;
